import { useEffect } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { getIdentityProvider } from "containers/App/actions";

// Might convert this into hook but for now will be functional component that returns null
const PostHireSSORedirect = ({
  identityProviderInfo,
  onSSORedirect,
  onGetIdentityProvider,
  identityProviderStatus,
}) => {
  const { search } = window.location;
  const urlParams = new URLSearchParams(search);
  const develop_ssoEmail = urlParams.get("develop_ssoEmail");

  useEffect(() => {
    if (develop_ssoEmail) {
      onGetIdentityProvider(develop_ssoEmail);
    }
  }, []);

  useEffect(() => {
    if (!develop_ssoEmail || identityProviderStatus !== "success") {
      return;
    }

    // If there is no client id, remove the develop_ssoEmail from the URL
    if (!identityProviderInfo.get("clientId")) {
      return urlParams.delete("develop_ssoEmail");
    }

    // If there is a client id, redirect to the SSO page
    sessionStorage.setItem("redirectToPosthireSSO", "true");
    onSSORedirect();
  }, [identityProviderInfo, identityProviderStatus]);

  return null;
};

PostHireSSORedirect.propTypes = {
  onSSORedirect: PropTypes.func,
  identityProviderInfo: PropTypes.object,
  identityProviderStatus: PropTypes.string,
  onGetIdentityProvider: PropTypes.func,
};

const mapStateToProps = (state) => ({
  identityProviderInfo: state.get("App").get("identityProviderInfo"),
  identityProviderStatus: state.get("App").get("identityProviderStatus"),
});

function mapDispatchToProps(dispatch) {
  return {
    onGetIdentityProvider: (emailAddress) =>
      dispatch(getIdentityProvider(emailAddress, null)),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostHireSSORedirect);
